module.exports = __webpack_public_path__ + "img/3_2_report.fbda1702.gif";